/* MAIYKO EKLENTI — Sepet ilerleme çubuğu: tek kaynak Liquid (v21, 17 Eyl 2026)

   SORUN: Temanın assets/cart.js'inde CartItems.updateProgressBar({total_price, items_subtotal_price})
   adet değişince (cart/change.js sonrası, bölümler yenilendikten SONRA) çubuğu TÜM sepet tutarından
   yeniden hesaplıyor ve snippets/cart-progress-bar-custom.liquid'in "ön sipariş hariç" hesabını eziyordu
   (mesaj/dolum/ikonlar bir Liquid'e bir JS'e göre değişiyor, çubuk zıplıyordu).

   ÇÖZÜM: Metot sarılır; yamalı wrapper (data-mk-kapsam-cents) varsa çubuğun bulunduğu bölüm
   Section Rendering API ile yeniden çekilir ve #cart-progress-wrapper Liquid çıktısıyla değiştirilir.
   Yamalı wrapper yoksa (eski tema) orijinal metot aynen çalışır. */
(function () {
  'use strict';
  if (window.__maiykoCubukKurulu) return;
  window.__maiykoCubukKurulu = true;

  var yamalandi = false;

  function yenidenCiz() {
    var w = document.getElementById('cart-progress-wrapper');
    if (!w) return;
    var sec = w.closest('.shopify-section');
    if (!sec || !sec.id) return;
    var id = sec.id.replace(/^shopify-section-/, '');
    var yol = (window.location && window.location.pathname) || '/';
    fetch(yol + '?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var yeni = doc.getElementById('cart-progress-wrapper');
        var eski = document.getElementById('cart-progress-wrapper');
        if (yeni && eski) eski.replaceWith(yeni);
      })
      .catch(function () { /* ağ hatası: mevcut çubuk kalır */ });
  }

  function kur() {
    if (yamalandi) return true;
    if (!window.customElements) return false;
    var C = customElements.get('cart-items');
    if (!C || !C.prototype || typeof C.prototype.updateProgressBar !== 'function') return false;
    var orijinal = C.prototype.updateProgressBar;
    C.prototype.updateProgressBar = function (toplamlar) {
      var w = document.getElementById('cart-progress-wrapper');
      if (!w) return;
      if (w.dataset.mkKapsamCents === undefined) return orijinal.call(this, toplamlar);
      yenidenCiz();
    };
    yamalandi = true;
    return true;
  }

  if (!kur()) {
    document.addEventListener('DOMContentLoaded', kur);
    window.addEventListener('load', kur);
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('cart-items').then(kur).catch(function () {});
    }
  }
})();
